import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Helper estándar de shadcn/ui: combina clases Tailwind resolviendo conflictos. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Formatea una duración en minutos a "Xh YYm". */
export function formatDuration(totalMinutes: number): string {
  const sign = totalMinutes < 0 ? '-' : '';
  const m = Math.abs(totalMinutes);
  const h = Math.floor(m / 60);
  const mm = m % 60;
  return `${sign}${h}h ${mm.toString().padStart(2, '0')}m`;
}

/** Formatea una hora en formato HH:MM en zona local. */
export function formatTime(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
}
